export default __webpack_public_path__ + "static/no-click-collect-1968e270791d1db91ce372d025487e74.svg";